<template>
	<div class="1c_data">
		<div class="panel-tag" v-if="this.data_p.length == 0">
			Panorama не знайдено
		</div>

		<div class="panel-body" v-else>
			<b-row>
				<b-col sm="4" class="left_pais">
					<div class="bg-light rounded-top mb-2" v-for="(pai) in this.data_p">
						<div id="js_list_accordion_2" class="accordion accordion-hover accordion-clean ">
							<div class="card ">
								<div class="card-header border">
									<a v-on:click="setActivePai(pai)" class="card-title"
									   :class="{'collapsed' : !pai.is_active, 'is_real_active border border-danger' : check_is_current(pai) }">
										<i class="fal fa-globe-americas width-2 fs-xl"></i>
										{{pai.params.kontragent}}
										<div class="ml-2">
											<small>{{pai.kadastr}} </small>
										</div>

									</a>
								</div>
							</div>
						</div>
					</div>

				</b-col>

				<b-col sm="8" class="right_pais">
					<div class="panorama_fields" >
						<div class="descriptions border p-3" v-if="pai_active != null" v-html="pai_active.description" >

						</div>
					</div>



				</b-col>
			</b-row>
		</div>
	</div>

</template>

<script>
export default {
	name: "data_panorama",

	props : {
		"data": {
			type : Array
		},
		owner : {
			type : String,
			default : "",
		},
		addon_fields: {
			type: Array,
		}
	},
	created() {

	},

	data() {
		return {
			data_p: [],
		}
	},
	mounted () {
		this.data_p = this.data;

		let self = this;
		setTimeout(function(){
			console.log('%c Mounted data_panorama:', "color: #1ab3a3",self.data_p,self.addon_fields);
			try {
				self.data_p.map(itm => {
					if(self.check_is_current(itm)) {
						self.setActivePai(itm);
					}
				});
			}
			catch (e) {
				console.log(e);
			}}, 300)

	},


	methods : {

		get_current_val(type) {
			let res = null;
			this.addon_fields.map(itm => {
				if(itm.field_type === type) {
					res = itm;
				}
			});

			return res;
		},


		setActivePai (pai) {
			try {
				this.data_p.map((item,idx) => {
					if(item.id === pai.id) {
						item.is_active = true;
					}
					else {
						item.is_active = false;
					}

					this.$set(this.data_p,idx,item);
				})



			}
			catch (e) {

			}
		},

		check_is_current(pai) {
			try {
				if (pai.id == this.pai_memorandum_active.id) {
					return true;
				}
			}
			catch (e) {

			}
			return false;
		}
	},

	computed : {

		pai_memorandum_active() {
			let cur = null;

			try {
				this.data_p.map(item => {
					let kontragent = this.owner;

					if(kontragent != null && kontragent == item.params.kontragent) {
						cur = item;
					}

				});
			}
			catch (e) {
				console.log(e);
			}

			return cur;
		},

		pai_active () {
			let active = null;
			try {
				if(this.data_p != null) {
					this.data_p.map(item => {
						if (item.is_active) {
							active = item;
						}
					});
				}
			}
			catch (e) {
				console.log(e);
			}

			return active;
		},
	}
}
</script>

<style scoped>

</style>
